import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import { useToasts } from "react-toast-notifications";
import QRCODE from "../../../assets/Home/qrcode.png";
import MenuCart from "./sub-components/MenuCart";
import actions, { useActions } from "../../../redux/actions";
import ErrorHandler from "../../../base/ErrorHandler";
import QRCodeModal from "../../../components/QRCodeModal";
import { setLocalSearchHistory } from "../../../helpers/generalHelper";
import QRCodeScannerModal from "../../../components/QRCodeScannerModal";

const IconGroup = ({ currency, wishlistData, compareData, iconWhiteClass }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const cookies = new Cookies();
  const token = cookies.get("token", { path: "/" });
  const role = cookies.get("role", { path: "/" });
  const allowLinksell = cookies.get("allowLinksell", { path: "/" }) === "true";
  const { addToast } = useToasts();

  const CartActions = useActions(actions.CartActions);
  const WishlistActions = useActions(actions.WishlistActions);
  const MeActions = useActions(actions.MeActions);

  const [showQrCode, setShowQrCode] = useState(false);
  const [showScanner, setShowScanner] = useState(false);

  const cartData = useSelector((state) => state.cartData);
  const storeConfig = useSelector((state) => state.storeConfig);

  const handleClick = (className) => {
    const elementToShow = document.getElementsByClassName(className)[0];

    if (elementToShow.classList.contains("active")) {
      elementToShow.classList.remove("active");
      return;
    }

    elementToShow.classList.add("active");

    ["search-content", "account-dropdown", "shopping-cart-content"]
      .filter((e) => e !== className)
      .forEach((e) => {
        const elementToHide = document.getElementsByClassName(e)[0];
        elementToHide.classList.remove("active");
      });
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
  };

  const onSearchSubmit = (e) => {
    const searchValue = e.target.search?.value || "";
    e.preventDefault();
    history.push("/browse", {
      search: searchValue,
    });
    if (searchValue !== "") setLocalSearchHistory(searchValue);
    history.go();
  };

  const deleteFromCart = (selectedItem, index, isRedeemable) => {
    const items = [...cartData.items].reduce(
      (acc, { product: { _id }, qty, orderAttribute }, i) => {
        if (
          _id !== selectedItem ||
          (isRedeemable && _id === selectedItem && index !== i)
        ) {
          acc.push({ product: _id, qty, orderAttribute });
        }
        return acc;
      },
      []
    );
    CartActions.updateOne(token, cartData._id, { items })
      .then(() => {
        addToast(t("cart.removed"), {
          appearance: "error",
          autoDismiss: true,
        });
        CartActions.getOne(token, cartData._id);
      })
      .catch(() => {
        CartActions.resetCart();
      });
  };

  const logout = () => {
    cookies.set("token", "", { path: "/" });
    cookies.set("role", "guest", { path: "/" });
    cookies.set("allowLinksell", false, { path: "/" });
    cookies.set("balance", 0, { path: "/" });
    cookies.set("tier", "", { path: "/" });
    MeActions.clearClaim();
    WishlistActions.clearWishlistDisplay();
    CartActions.resetCart();
  };

  const onClickWishlist = () => {
    if (token) {
      history.push("/wishlist");
    } else {
      history.push("/login-register");
    }
  };

  const toggleShowScanner = () => setShowScanner((prevState) => !prevState);

  useEffect(() => {
    if (!cartData._id) {
      CartActions.allocateCart(token).catch((error) => {
        if (error.message.includes("invalid signature")) {
          window.alert(t("navMenu.sessionExpired"));
          logout();
        } else {
          ErrorHandler(error);
        }
      });
    } else {
      CartActions.getOne(token, cartData._id).catch((error) => {
        if (error.message.includes("invalid signature")) {
          window.alert(t("navMenu.sessionExpired"));
          logout();
        } else {
          CartActions.resetCart();
        }
      });
    }
  }, [cartData._id, token]);

  return (
    <div className={`header-right-wrap ${iconWhiteClass || ""}`}>
      <div className="same-style header-search d-none d-lg-block">
        <button
          type="button"
          className="search-active"
          onClick={() => handleClick("search-content")}
        >
          <i className="pe-7s-search" />
        </button>
        <div className="search-content">
          <form action="#" id="header_search_form" onSubmit={onSearchSubmit}>
            <input type="text" name="search" placeholder={t("search")} />
            <button
              className="button-search"
              type="submit"
              form="header_search_form"
            >
              <i className="pe-7s-search" />
            </button>
          </form>
        </div>
      </div>

      <div className="same-style account-setting d-block d-lg-block">
        <button
          type="button"
          className="account-setting-active"
          onClick={() => handleClick("account-dropdown")}
        >
          <i className="pe-7s-user-female" />
        </button>
        <div className="account-dropdown">
          <ul>
            {!token && (
              <li>
                <Link to={`${process.env.PUBLIC_URL}/login-register`}>
                  {t("navMenu.login")}
                </Link>
              </li>
            )}
            {!token && (
              <li>
                <Link to={`${process.env.PUBLIC_URL}/login-register`}>
                  {t("navMenu.register")}
                </Link>
              </li>
            )}
            {token && (
              <li>
                <Link to={`${process.env.PUBLIC_URL}/my-account`}>
                  {t("navMenu.myAccount")}
                </Link>
              </li>
            )}
            {token && role === "merchant_admin" && (
              <li>
                <Link to={`${process.env.PUBLIC_URL}/customer-redemption`}>
                  {t("navMenu.redemption")}
                </Link>
              </li>
            )}
            {token && (
              <li>
                <Link onClick={() => logout()} to="#">
                  {t("navMenu.logout")}
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>

      {storeConfig?.module?.redeem?.enable && token && role === "customer" && (
        <div className="same-style header-compare">
          <button
            type="button"
            onClick={() => {
              setShowQrCode(true);
            }}
          >
            <img src={QRCODE} alt="" style={{ height: 24, width: 24 }} />
          </button>
        </div>
      )}

      <div className="same-style header-compare">
        <button
          className="button-search"
          type="button"
          onClick={toggleShowScanner}
        >
          <i className="pe-7s-camera" />
        </button>
      </div>

      <div className="same-style header-compare">
        <Link to={`${process.env.PUBLIC_URL}/compare`}>
          <i className="pe-7s-shuffle" />
          <span className="count-style">
            {compareData && compareData.length ? compareData.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style header-wishlist">
        <button onClick={onClickWishlist}>
          <i className="pe-7s-like" />
          <span className="count-style">
            {wishlistData && wishlistData.length ? wishlistData.length : 0}
          </span>
        </button>
      </div>
      {(allowLinksell || role === "guest" || role === "customer") && (
        <div className="same-style cart-wrap d-none d-lg-block">
          <button
            className="icon-cart"
            onClick={() => handleClick("shopping-cart-content")}
          >
            <i className="pe-7s-shopbag" />
            <span className="count-style">
              {Array.isArray(cartData.items) ? cartData.items.length : 0}
            </span>
          </button>
          {/* menu cart */}
          <MenuCart
            cartData={cartData}
            currency={currency}
            deleteFromCart={deleteFromCart}
            allowLinksell={allowLinksell}
          />
        </div>
      )}
      {(allowLinksell || role === "guest" || role === "customer") && (
        <div className="same-style cart-wrap d-block d-lg-none mr-2">
          <Link className="icon-cart" to={`${process.env.PUBLIC_URL}/cart`}>
            <i className="pe-7s-shopbag" />
            <span className="count-style">
              {Array.isArray(cartData.items) ? cartData.items.length : 0}
            </span>
          </Link>
        </div>
      )}
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
        >
          <i className="pe-7s-menu" />
        </button>
      </div>

      <QRCodeModal showQrCode={showQrCode} setShowQrCode={setShowQrCode} />
      <QRCodeScannerModal show={showScanner} toggleShow={toggleShowScanner} />
    </div>
  );
};

IconGroup.propTypes = {
  cartData: PropTypes.object,
  compareData: PropTypes.array,
  currency: PropTypes.object,
  iconWhiteClass: PropTypes.string,
  wishlistData: PropTypes.array,
};

const mapStateToProps = (state) => ({
  currency: state.currencyData,
  cartData: state.cartData,
  wishlistData: state.wishlistData.wishlistItems,
  compareData: state.compareData,
});

export default connect(mapStateToProps)(IconGroup);
